import React from "react";
import { Link } from "react-router-dom";
import { MT5_WINDOWS_URL, MT5_IOS_URL, MT5_ANDROID_URL } from "../../lib/api";

const companyLinks = [
    { to: "/about", label: "About Us" },
    { to: "/blogs", label: "Blog" },
    { to: "/contact", label: "Contact" },
];

const tradingLinks = [
    { to: "/platform", label: "MT5 Platform" },
    { to: "/platform", label: "Live Account" },
    { to: "/platform", label: "Demo Account" },
];

const downloadLinks = [
    { href: MT5_WINDOWS_URL, label: "Windows Terminal", testId: "footer-download-windows" },
    { href: MT5_IOS_URL, label: "iOS App", testId: "footer-download-ios" },
    { href: MT5_ANDROID_URL, label: "Android App", testId: "footer-download-android" },
];

const legalLinks = [
    "Risk Disclosure",
    "Privacy Policy",
    "Terms of Service",
    "AML Policy",
];

function ColumnTitle({ children, className = "mb-4" }) {
    return <p className={`text-white font-bold text-sm ${className}`}>{children}</p>;
}

function InternalLinkList({ items }) {
    return (
        <ul className="space-y-3 text-sm text-slate-400">
            {items.map((l) => (
                <li key={l.label}>
                    <Link to={l.to} className="hover:text-[#A6E3DC]">
                        {l.label}
                    </Link>
                </li>
            ))}
        </ul>
    );
}

function ExternalLinkList({ items }) {
    return (
        <ul className="space-y-3 text-sm text-slate-400">
            {items.map((l) => (
                <li key={l.label}>
                    <a
                        href={l.href}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={l.testId}
                        className="hover:text-[#A6E3DC]"
                    >
                        {l.label}
                    </a>
                </li>
            ))}
        </ul>
    );
}

export default function FooterLinks() {
    return (
        <>
            <div>
                <ColumnTitle>Company</ColumnTitle>
                <InternalLinkList items={companyLinks} />
            </div>

            <div>
                <ColumnTitle>Trading</ColumnTitle>
                <InternalLinkList items={tradingLinks} />
                <ColumnTitle className="mb-4 mt-8">Download MT5</ColumnTitle>
                <ExternalLinkList items={downloadLinks} />
            </div>

            <div>
                <ColumnTitle>Legal</ColumnTitle>
                <ul className="space-y-3 text-sm text-slate-400">
                    {legalLinks.map((label) => (
                        <li key={label}>
                            <a href="#" className="hover:text-[#A6E3DC]">
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}
